import LeadGenNotFoundModal from "./LeadGenNotFoundModal";
import { useDispatch, useSelector } from "react-redux";
import { selectNotFoundLeadGenModalOpen } from "app/pages/sales-intelligence/sub-modules/common/store/selectors";
import { toggleNotFoundLeadGenModalOpen } from "app/pages/sales-intelligence/sub-modules/common/store/action-creators";

const LeadGenNotFoundModalContainer = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector(selectNotFoundLeadGenModalOpen);

    return (
        <LeadGenNotFoundModal
            isOpen={isOpen}
            onOpen={(toggleOpen: boolean) => {
                dispatch(toggleNotFoundLeadGenModalOpen(toggleOpen));
            }}
        />
    );
};

export default LeadGenNotFoundModalContainer;
